import { AmLogo } from '@approvalmax/ui';
import { Box, Flex, Text, useLayout } from '@approvalmax/ui/src/components';
import { Helmet } from 'react-helmet';
import { MobileApps } from 'shared/components';

import { messages } from './resources/messages';

export const Page = () => {
    useLayout({ containerMinSize: 'xxsmall' });

    return (
        <Flex alignItems='center' justifyContent='center' height='100%'>
            <Helmet title={messages.title} />

            <Box spacing='32 24' maxWidth={500}>
                <Flex justifyContent='center'>
                    <AmLogo width={159} />

                    <Text font='body' textAlign='center' spacing='20 0'>
                        {messages.description({ br: <br /> })}
                    </Text>

                    <MobileApps />
                </Flex>
            </Box>
        </Flex>
    );
};

export default Page;
